<template>
    <v-layout align-center justify-center class="age-intro-wrap" v-if="this.$userData.age && !!$gameData.images.titleleaf">
        <img class="age-intro" :src="template.url" />
    </v-layout>
</template>

<script>
    export default {
        data() {
            return {
               image: '',
            }
        },
        computed: {
            template() {
                const age = this.$userData.age
                let gender = [20, 70].indexOf(age) > -1 ? 'a' : this.$userData.gender.toLowerCase()
                return this.$gameData.images.titleleaf[age][gender]
            }
        },
        watch: {
            '$userData.age': {
                handler(val) {
                }
            }
        },
        beforeDestroy() {
            this.$eventBus.$off('SHOW_AGE_INTRO')
        },
        mounted() {
            this.$eventBus.$on('SHOW_AGE_INTRO', _ => {
                this.$stopAll()
                this.$playAudio(3)
                $('.age-intro').show(500)

                setTimeout(_ => {
                    $('.age-intro').hide(500)
                }, 4000)
            })
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    .age-intro-wrap {
        position: absolute;
        top: 0; bottom: 0;
        left: 0; right: 0;
        pointer-events: none;

        .age-intro {
            display: none;
        }
    }
</style>
